import {Grid} from "@mui/material";
import {PuiDialog, PuiSection, PuiTable} from "@portnet/ui";
import moment from "moment";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import AppTextField from "../../../../common/components/inputs/AppTextField";
import {historiqueSouscriptionTableColumns} from "../others/historiqueSouscriptionTableColumns";
import * as actionsHistory from "../state/historiqueSouscriptionActions";

const HistoriqueSouscription = ({ open, close, selected }) => {
  const dispatch = useDispatch();
  const { content: historiqueListe, isLoading: isHistoriqueListeLoading } =
    useSelector(
      (state) => state.souscription.historySouscription.historiqueListe
    );

  useEffect(() => {
    if (Boolean(selected?.id)) {
      dispatch(actionsHistory.getHistorySouscriptionsAction(selected?.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected?.id]);

  return (
    <>
      <PuiDialog
        onClose={close}
        open={open}
        maxWidth="lg"
        fullWidth
        title="Historique de la souscription"
      >
        <PuiSection title="Données de la souscription">
          <Grid container marginTop={1}>
            <Grid item xs={6} sm={6} md={6}>
              <AppTextField
                label="Code du package"
                value={selected?.codePackage}
                consultation
                formik={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <AppTextField
                label="Identifiant de la sousciption"
                value={selected?.identifiantSouscription}
                consultation
                formik={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <AppTextField
                label="Transactions restantes"
                value={selected?.tarificationSummary?.restant}
                consultation
                formik={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <AppTextField
                label="Fin de la validité"
                value={moment(new Date(selected?.validiteAu)).format(
                  "DD/MM/yyyy HH:mm "
                )}
                consultation
                formik={false}
              />
            </Grid>
          </Grid>
        </PuiSection>
        <PuiSection
          sx={{ marginTop: 2 }}
          title="Historique des évenements liés à la souscripion"
        >
          <PuiTable
            columns={historiqueSouscriptionTableColumns}
            rows={historiqueListe}
            loading={isHistoriqueListeLoading}
            pageSize={5}
            getRowId={(row) => row.sequence}
          />
        </PuiSection>
      </PuiDialog>
    </>
  );
};
export default HistoriqueSouscription;
